import axios from "axios";
import React, { useEffect, useRef, useState } from "react";

import { track_event } from "base/analytics";
import { COUNTRY_PHONE_CODES_LIST } from "base/constants";
import { GenericException } from "base/ui/errors";
import { LoadingOverlay } from "base/ui/status";
import { SuggestedField } from "base/ui/suggested_field";

import { FormErrorText } from "../../components/ui/FormErrorText";

export const DEFAULT_FEATURES = [
  { id: 0, name: "Sales" },
  { id: 1, name: "Marketing" },
  { id: 2, name: "Customer Support" },
  { id: 3, name: "Customized Chatbots/AI-Agent" }
]

export const PRICING_PREFERENCES = [
  "Starter - $69.99/month", "Growth - $299/month", "Pro - Get In Touch"
]

export const INDUSTRIES = [
  "Automotive",
  "Financial Services",
  "Consumer Electronics",
  "Beauty, Fashion & Accessories",
  "Food, Beverages & Restaurants",
  "Health & Supplements",
  "Manufacturing",
  "Travel & Hospitality",
  "Media & Entertainment",
  "Sports & Fitness",
  "Agriculture & Dairy",
  "Retail & E - Commerce",
  "Other(please specify)"
]

function ContactUsForm({ title, formType, onSubmit }) {
  const ctx = useRef({}).current;
  const [show_error, setShowError] = useState(null);
  const [is_loading, setIsLoading] = useState(false);
  const [country_phone_code, setCountryPhoneCode] = useState();
  const [selected_countries, setSelectedCountries] = useState([])
  const [selected_industry, setSelectedIndustry] = useState()

  function getFullPhoneNumber(phoneNumber) {
    const country = COUNTRY_PHONE_CODES_LIST.find((eachCountry) => {
      return eachCountry.code === country_phone_code
    })
    return `${country.dial_code.replace("+", "")}${phoneNumber.replace(/^0+/, '')}`
  }

  const updateField = (key) => {
    return (evt) => {
      ctx[key] = evt.target.value
      setShowError(null)
    }
  }

  useEffect(() => {
    axios.get("/user/location").then(
      (resp) => {
        if (resp.data) {
          const country = COUNTRY_PHONE_CODES_LIST.find((eachCountry) => {
            return eachCountry.dial_code === `+${resp.data.phone_code}`
          })
          setCountryPhoneCode(country.code)
        }
      }
    )
  }, [])

  useEffect(() => {
    // Loading fonts
    import('../../css/landing.css')
  }, []);

  function submitForm() {
    if (!ctx.firstname?.length) {
      setShowError({ "name": true })
      return
    }
    if (!ctx.email?.length) {
      setShowError({ "email": true })
      return
    }
    if (!ctx.mobilephone || ctx.mobilephone?.length < 7 || ctx.mobilephone?.length > 20) {
      setShowError({ "mobilephone": true })
      return
    }
    if (!ctx.company?.length) {
      setShowError({ "company": true })
      return
    }
    if (!selected_industry) {
      setShowError({ "industry": true })
      return
    }
    if (selected_industry === "Other(please specify)" && !ctx.industry) {
      setShowError({ "industry": true })
      return
    }
    // const selected_features = DEFAULT_FEATURES.filter((feature) => feature.checked)
    // if (selected_features.length === 0) {
    //   setShowError({ "features": true })
    //   return
    // }
    if (!ctx.pricing_preferences) {
      setShowError({ "pricing": true })
      return
    }
    // const features = selected_features.map((feature) => feature.name).join(", ")

    const payload = {
      "fields": [
        {
          "objectTypeId": "0-1",
          "name": "email",
          "value": ctx.email
        },
        {
          "objectTypeId": "0-1",
          "name": "firstname",
          "value": ctx.firstname
        },
        {
          "objectTypeId": "0-1",
          "name": "company",
          "value": ctx.company
        },
        {
          "objectTypeId": "0-1",
          "name": "hs_whatsapp_phone_number",
          "value": getFullPhoneNumber(ctx.mobilephone)
        },
        {
          "objectTypeId": "0-1",
          "name": "industry",
          "value": selected_industry === "Other(please specify)" ? ctx.industry : selected_industry
        },
        {
          "objectTypeId": "0-1",
          "name": "pricing_preferences",
          "value": ctx.pricing_preferences
        },
        // {
        //   "objectTypeId": "0-1",
        //   "name": "feature",
        //   "value": features
        // }
      ],
      "context": {
        "pageUri": window.location.href,
        "pageName": "BookDemo"
      }
    }

    if (ctx.website) {
      payload.fields.push(
        {
          "objectTypeId": "0-1",
          "name": "website",
          "value": ctx.website
        }
      )
    }
    if (selected_countries.length > 0) {
      const countries = selected_countries.map((val) => {
        return val.name;
      }).join(',');

      payload.fields.push(
        {
          "objectTypeId": "0-1",
          "name": "country",
          "value": countries
        }
      )
    }

    setIsLoading(true)
    track_event("bookdemo_submit")

    axios.post(`/company/contact?action=${formType}`, payload).then(
      (resp) => {
        if (resp.data.status === 'error') {
          if (resp.data.errors) {
            if (resp.data.errors[0]?.errorType === "BLOCKED_EMAIL") {
              setShowError({ "email": true })
            } else {
              GenericException.showPopup(resp.data.errors[0]?.message || "Please enter valid details", "Error");
            }
            return;
          }
          return
        }
        onSubmit ? onSubmit(ctx.firstname, ctx.email) : window.open("thankyou", "_self")
        document.getElementById("input_email").value = ""
        document.getElementById("input_phone").value = ""
        document.getElementById("input_name").value = ""
        document.getElementById("input_company").value = ""
        document.getElementById("input_website").value = ""
        ctx.firstname = ""
        ctx.email = ""
        ctx.mobilephone = ""
        ctx.company = ""
        ctx.website = ""
      }
    ).finally(() => setIsLoading(false));
  }
  return <div className='tw-bg-white tw-rounded-xl tw-p-6 tw-w-full'>
    {
      is_loading ? <LoadingOverlay /> : null
    }
    {
      title
        ? <p className='tw-text-[20px] md:tw-text-[28px] tw-font-medium'>Book a demo with us today</p>
        : null
    }
    <div className={`${title ? 'tw-my-4' : ''}`}>
      <p className='tw-text-[11px] md:tw-text-[14px] tw-mb-1 tw-text-[#202223]'>Name*</p>
      <input id='input_name' className='tw-border tw-px-4 tw-rounded tw-text-sm tw-py-2 tw-w-full' placeholder='Enter Your Name'
        onChange={updateField("firstname")} />
      {show_error?.name ? <FormErrorText msg="Please enter your name" /> : null}
    </div>
    <div className='tw-mb-4'>
      <p className='tw-text-[11px] md:tw-text-[14px] tw-mb-1 tw-text-[#202223]'>Business Email*</p>
      <input id='input_email' type="email" className='tw-border tw-px-4 tw-rounded tw-text-sm tw-py-2 tw-w-full' placeholder='Enter Your Business Email'
        onChange={updateField("email")} />
      {show_error?.email ? <FormErrorText msg="Please provide valid Business Email" /> : null}
    </div>
    <div className='tw-mb-4'>
      <p className='tw-text-[11px] md:tw-text-[14px] tw-mb-1 tw-text-[#202223]'>WhatsApp Number*</p>
      <div className="tw-flex tw-border tw-rounded tw-text-sm tw-p-1 tw-w-full">
        <select className="tw-outline-none tw-text-xs tw-py-2 tw-mr-1 tw-w-[136px]"
          onChange={(e) => setCountryPhoneCode(e.target.value)}
          // COUNTRY_PHONE_CODES_LIST.find((i) => i.code === e.target.value).dial_code.replace("+", "")
          value={country_phone_code}>
          {COUNTRY_PHONE_CODES_LIST.map(obj => (
            <option key={obj.code} value={obj.code}>{obj.flag} {obj.name} {obj.dial_code}</option>
          ))}
        </select>
        <input id='input_phone' className='tw-outline-none tw-text-md tw-p-2 tw-mr-1 tw-w-full' placeholder='Enter WhatsApp Number'
          onChange={updateField("mobilephone")} />
      </div>
      {show_error?.mobilephone ? <FormErrorText msg="Please enter valid phone number" /> : null}
      <div className="tw-text-xs tw-mt-1 tw-text-gray-400">
        *As a platform built around WhatsApp, we&apos;ll send you a demo to show you first hand what an interaction with your clients could look like.
      </div>

    </div>

    <div className="tw-grid lg:tw-grid-cols-2 lg:tw-gap-4">

      <div className='tw-mb-4 tw-flex-1'>
        <p className='tw-text-[11px] md:tw-text-[14px] tw-mb-1 tw-text-[#202223]'>Company Name*</p>
        <input id='input_company' className='tw-border tw-px-4 tw-rounded tw-text-sm tw-py-2 tw-w-full' placeholder='Enter Company Name'
          onChange={updateField("company")} />
        {show_error?.company ? <FormErrorText msg="Please enter company name" /> : null}
      </div>
      <div className='tw-mb-4 tw-flex-1'>
        <p className='tw-text-[11px] md:tw-text-[14px] tw-mb-1 tw-text-[#202223]'>Shop URL</p>
        <input id='input_website' className='tw-border tw-px-4 tw-rounded tw-text-sm tw-py-2 tw-w-full'
          placeholder='Enter your store URL'
          onChange={updateField("website")} />
        {show_error?.website ? <FormErrorText msg="Please enter your store URL" /> : null}
      </div>
    </div>

    <div className='tw-mb-4'>
      <p className='tw-text-[11px] md:tw-text-[14px] tw-mb-1 tw-text-[#202223]'>Industry*</p>
      <div className="tw-flex tw-flex-wrap tw-gap-2 md:tw-gap-4">
        <select className="tw-border tw-rounded tw-text-sm tw-p-2 max-md:tw-w-full md:tw-flex-1"
          defaultValue=""
          onChange={(e) => {
            setSelectedIndustry(e.target.value)
            setShowError(null)
          }}>
          <option value="" disabled={true}>Select Industry</option>
          {INDUSTRIES.map((industry) => {
            return (
              <option key={industry} value={industry}>{industry}</option>
            )
          })}
        </select>
        {
          selected_industry === "Other(please specify)"
            ?
            <div className="max-lg:tw-w-full tw-flex-1">
              <input id='input_company' className='tw-border tw-rounded tw-text-sm tw-px-4 tw-py-2 tw-w-full' placeholder='Enter Industry'
                onChange={updateField("industry")} />
            </div>
            : null
        }
      </div>
      {show_error?.industry ? <FormErrorText msg={selected_industry ? "Please enter industry" : "Please select industry"} /> : null}
    </div>

    {/* <div className='tw-mb-4'>
      <p className='tw-text-[11px] md:tw-text-[14px] tw-mb-1 tw-text-[#202223]'>What Sukhiba features are you interested in?*</p>
      <div className="tw-flex tw-flex-wrap tw-gap-2">
        {
          DEFAULT_FEATURES.map((feature) => {
            return (
              <label key={feature.id}>
                <input className="tw-checkbox" type='checkbox' onChange={(e) => {
                  setKeyPath(DEFAULT_FEATURES, `${feature.id  }.checked`, e.target.checked)
                  setShowError(null)
                }} />
                <span className='tw-ml-1 tw-text-sm tw-text-gray-600'>{feature.name}</span>
              </label>
            )
          })
        }
      </div>
      {show_error?.features ? <FormErrorText msg="Please select a feature" /> : null}
    </div> */}
    <div className='tw-mb-4'>
      <p className='tw-text-[11px] md:tw-text-[14px] tw-mb-1 tw-text-[#202223]'>Country</p>

      <SuggestedField
          selection_list={COUNTRY_PHONE_CODES_LIST}
          props={{
            "show_results_on_render": false,
            "min_search_text_length": 2,
            "title_key_path": "name",
            "results_key_path": "name",
            "title_format": "{name}",
            "image_key_path": null,
            "placeholder": "Search Country",
            "result_renderer": (item) => <p className="tw-p-1 !tw-font-light">{item.name} {item.flag}</p>,
            "selected_renderer": (item, onRemove) => <div className="tw-bg-white tw-flex tw-px-1 tw-border tw-rounded tw-items-center tw-my-1 tw-mr-1">
              <span className="tw-text-sm tw-text-center tw-text-primary">{item.name} {item.flag}</span>
              <span className='tw-text-lg tw-text-black-500 tw-pl-2 tw-cursor-pointer' onClick={onRemove}>&times;</span>
            </div>,
            "selected_values_classname": "tw-flex tw-flex-wrap",
            "hide_no_results": true
        }}
        className=""
        selected={selected_countries}
        onSelect={(selected) => {
          setSelectedCountries(selected)
        }}
      />
      <div className="tw-text-xs tw-mt-1 tw-text-gray-400">
        *Where your business operates
      </div>

    </div>

    <div className='tw-mb-4'>
      <p className='tw-text-[11px] md:tw-text-[14px] tw-mb-1 tw-text-[#202223]'>Select the plan that you would like to explore*</p>
      <div className="tw-flex tw-flex-wrap tw-gap-2 md:tw-gap-4">
        <select className="tw-border tw-rounded tw-text-sm tw-p-2 max-md:tw-w-full md:tw-flex-1"
          defaultValue=""
          onChange={(e) => {
            ctx.pricing_preferences = e.target.value
            setShowError(null)
          }}>
          <option value="" disabled={true}>Select Plan</option>
          {PRICING_PREFERENCES.map((plan) => {
            return (
              <option key={plan} value={plan}>{plan}</option>
            )
          })}
        </select>        
      </div>
      {show_error?.pricing ? <FormErrorText msg="Please select a plan that you would like to explore" /> : null}
    </div>
    <button className='tw-w-full tw-rounded-full tw-mt-4 tw-bg-landing-green tw-px-6 md:tw-px-12 tw-text-white tw-py-3.5 tw-tracking-wide'
      onClick={submitForm} type="submit">Submit</button>
  </div>
}


export default ContactUsForm;
